<template>
<router-view></router-view>
</template>

<script>
export default {
  name: 'Audit'
};
</script>

<style lang="less" scoped>
</style>
